export const UNKNOWN_ERROR = "Wystąpił nieznany błąd";
export const EMPTY_NUMBER = "Numer paska nie może być pusty!";
export const PHONE_VALIDATOR = "Błędny format nr. telefonu! Wymagane (000-000-000 lub 000000000)";
export const EMAIL_VALIDATOR = "Błędny format adresu email! Wymagane user@example.com";
export const NAME_VALIDATOR = "Błędny format! Wprowadź poprawne imię i nazwisko";
export const LENGTH_VALIDATOR = (length: number) => `To pole musi mieć ${length} znaków`;
export const MIN_VALIDATOR = (min: number) => `Minimalna wartość to: ${min}`;
export const REQUIRED_VALIDATOR = "To pole nie może być puste";
export const ZIP_CODE_VALIDATOR = "Błędny format kodu pocztowego! Wymagane 00-000";
export const PASSWORD_VALIDATOR = "Hasło powinno składać się z min. 8 znaków zawierających małe i wielkie litery oraz cyfry lub znaki specjalne";